module.exports = __webpack_public_path__ + "static/9-dae6cb2337e3a4b224482d9cc1e97e42.jpg";